import { useCallback } from 'react';
import { handleOnChange } from './handleOnChange';
export var useOnRemoveMultiple = function useOnRemoveMultiple(setInternalValue, internalValue, onChange) {
  return useCallback(function (tagValuesToRemove) {
    var nextValue = internalValue.filter(function (value) {
      return !tagValuesToRemove.includes(value);
    });
    handleOnChange(nextValue, onChange);
    setInternalValue(nextValue);
  }, [setInternalValue, internalValue]);
};